export default __webpack_public_path__ + "static/media/product-image-9.90218b51.jpg";